import { Grid2 } from "@mui/material";
import { useEffect } from "react";
import useUIBp from "../../../../../../Hooks/useUIBoilerplate";
import { UIactions } from "../../../../../../store/slices/UI";
import TextField from "../../../../../UI/GeneralPurpose/SimpleTextField";

const UIText = {
  "es-CL": { label: "De", placeholder: "mail@dominio.cl" },
  "en-US": { label: "From", placeholder: "mail@domain.cl" },
};

export const FromId = "mail-from";
const id = FromId;

const From = () => {
  const { dispatch,UI } = useUIBp();
  const filter = UI.filter ?? "";

  useEffect(() => {
    const fromMatch = filter.match(/from:\(([^)]+)\)/);
    const fromValue = fromMatch ? fromMatch[1] : "";

    if (fromValue){
        dispatch(UIactions.setField({ id, value: fromValue }));
    }
  }, [dispatch, filter]);

  return (
    <Grid2 container {...{ size: 12, paddingTop: 2 }}>
      <TextField clearOnUnmount {...{ id, UIText, size: 12 }} />
    </Grid2>
  );
};

export default From;
